import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum CampaignStatus {
  Unknown,
  Open,
  Closed,
}

interface CampaignInitialState {
  status: CampaignStatus
}

const initialState: CampaignInitialState = {
  status: CampaignStatus.Unknown,
}

export const CampaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<CampaignStatus>) => {
      state.status = action.payload
    },
  },
})

export const { actions } = CampaignSlice

export default CampaignSlice.reducer
